"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraInterpolationManager = void 0;
var TWEEN = require("@tweenjs/tween.js");
var GlobalUtils_js_1 = __importDefault(require("../../../../../shared/util/GlobalUtils.js"));
var CameraLinearInterpolation_1 = require("./interpolationMethods/CameraLinearInterpolation");
var CameraSphericalInterpolation_1 = require("./interpolationMethods/CameraSphericalInterpolation");
var CameraCylindricalInterpolation_1 = require("./interpolationMethods/CameraCylindricalInterpolation");
var CameraMultipleInterpolation_1 = require("./interpolationMethods/CameraMultipleInterpolation");
var CameraInterpolationManager = /** @class */ (function () {
    // #endregion Properties (3)
    // #region Constructors (1)
    function CameraInterpolationManager(_cameraControls) {
        this._cameraControls = _cameraControls;
        // #region Properties (3)
        this._globalUtils = GlobalUtils_js_1.default;
        this.Tween = /** @class */ (function () {
            function class_1(options, cb, onComplete) {
                var _this = this;
                this._properties = { delta: 0 };
                this._tween = new TWEEN.Tween(this._properties);
                this._tween.easing(options.easing);
                this._tween.to({ delta: 1.0 }, options.duration);
                this._tween.onUpdate(function (v) {
                    cb.onUpdate(v);
                });
                this._tween.onStop(function (v) {
                    if (cb.onStop)
                        cb.onStop(v);
                    _this._resolve(true);
                });
                this._tween.onComplete(function (v) {
                    if (cb.onComplete)
                        cb.onComplete(v);
                    onComplete();
                    _this._resolve(true);
                });
            }
            class_1.prototype.start = function () {
                var _this = this;
                return new Promise(function (resolve) {
                    _this._resolve = resolve;
                    _this._tween.start();
                });
            };
            class_1.prototype.stop = function () {
                this._tween.stop();
            };
            return class_1;
        }());
        this._tween = null;
    }
    // #endregion Constructors (1)
    // #region Public Methods (3)
    CameraInterpolationManager.prototype.active = function () {
        return this._tween ? true : false;
    };
    /**
     * cameraTween
     */
    CameraInterpolationManager.prototype.interpolate = function (path, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        if (this._tween) {
            this._tween.stop();
            this._tween = null;
        }
        var parsedOptions = this.optionsParser(options);
        this._tween = new this.Tween(parsedOptions, path.length === 2 ?
            this.getCameraInterpolation(path[0], path[1], parsedOptions.coordinates) :
            new CameraMultipleInterpolation_1.CameraMultipleInterpolation(this._cameraControls, path, parsedOptions.interpolation), function () { _this._tween = null; });
        return this._tween.start();
    };
    CameraInterpolationManager.prototype.stop = function () {
        if (this._tween)
            this._tween.stop();
        this._tween = null;
    };
    // #endregion Public Methods (3)
    // #region Private Methods (2)
    CameraInterpolationManager.prototype.getCameraInterpolation = function (from, to, type) {
        switch (type) {
            case 'spherical':
                return new CameraSphericalInterpolation_1.CameraSphericalInterpolation(this._cameraControls, from, to);
            case 'cylindrical':
                return new CameraCylindricalInterpolation_1.CameraCylindricalInterpolation(this._cameraControls, from, to);
            default:
                return new CameraLinearInterpolation_1.CameraLinearInterpolation(this._cameraControls, from, to);
        }
    };
    CameraInterpolationManager.prototype.optionsParser = function (options) {
        return {
            default: options.default || false,
            duration: this._globalUtils.typeCheck(options.duration, 'notnegative') ? options.duration : 0,
            easing: this._globalUtils.typeCheck(options.easing, 'string') ? this._globalUtils.getAtPath(TWEEN.Easing, options.easing) || TWEEN.Easing.Quartic.InOut : typeof options.easing === 'function' ? options.easing : TWEEN.Easing.Quartic.InOut,
            coordinates: options.coordinates !== 'spherical' && options.coordinates !== 'linear' && options.coordinates !== 'cylindrical' ? 'cylindrical' : options.coordinates,
            interpolation: this._globalUtils.typeCheck(options.interpolation, 'string') ? this._globalUtils.getAtPath(TWEEN.Interpolation, options.interpolation) || TWEEN.Interpolation.CatmullRom : typeof options.interpolation === 'function' ? options.interpolation : TWEEN.Interpolation.CatmullRom
        };
    };
    return CameraInterpolationManager;
}());
exports.CameraInterpolationManager = CameraInterpolationManager;
